module.exports = __webpack_public_path__ + "img/btcz.378fe0fd.svg";